import { render, staticRenderFns } from "./TeamPayment.vue?vue&type=template&id=5272b3b3&scoped=true"
import script from "./TeamPayment.vue?vue&type=script&lang=js"
export * from "./TeamPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5272b3b3",
  null
  
)

export default component.exports